import type { Event } from 'models';
import { EventDetailInvitees } from './event-detail-invitees';
import { ReminderDetailInvitees } from './reminder-detail-invitees';

type P = {
  event: Event;
};

const EventDetailInviteesWrapper = ({ event }: P) => {
  if (event.type === 'reminder') {
    return <ReminderDetailInvitees event={event} />;
  }

  return <EventDetailInvitees event={event} />;
};

export default EventDetailInviteesWrapper;
